<template>
  <nav class="navbar sticky-top navbar-light bg-light">
    <div class="navbar-container container-fluid">
      <div class="navbar-heading-container align-items-center ms-3">
        <router-link class="navbar-brand text-black" to="/user-profile?page=1">
          Demand Letter Tool
        </router-link>
      </div>

      <div class="navbar-control-container d-flex me-3">
        <div
          id="offcanvas"
          class="offcanvas offcanvas-end w-menu"
          data-bs-scroll="true"
          tabindex="-1"
          data-bs-keyboard="false"
          data-bs-backdrop="true"
        >
          <div class="offcanvas-header border-bottom">
            <h6
              id="offcanvas"
              class="offcanvas-title d-none d-sm-block fw-bold"
            >
              Menu
            </h6>
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
          <div class="offcanvas-body px-0">
            <ul
              id="menu"
              class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-start"
            >
              <li
                v-for="(button, key) in navigationButtons"
                :key="key"
                class="nav-item"
              >
                <component :is="button.component" v-bind="button.props" />
              </li>
            </ul>
          </div>
        </div>
        <dropdown-button
          button-text="New Session"
          :handler="handleNewSession"
          class="me-3"
        />
        <dropdown-button
          button-text="Sessions List"
          :handler="handleSessionList"
          class="me-3"
        />
        <button
          class="navbar-toggler d-flex text-dark fw-bold border-black p-2"
          type="button"
          data-bs-toggle="offcanvas"
          aria-controls="offcanvasScrolling"
          data-bs-target="#offcanvas"
          role="button"
        >
          <span class="navbar-toggler-icon" />
          <i
            class="bi bi-arrow-right-square-fill fs-3"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvas"
          />
        </button>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import DropdownMenu from '@/components/DropdownMenu.vue';
import { getNavigationButtons } from '@/common/utils';
import { defineComponent } from 'vue';
import { NavigationButton } from '@/types/NavigationButton';
import DropdownButton from '@/components/DropdownButton.vue';

export default defineComponent({
  name: 'NavbarComponent',

  components: {
    DropdownButton,
    DropdownMenu,
  },

  data() {
    return {
      navigationButtons: [] as NavigationButton[],
    };
  },

  async created() {
    this.navigationButtons = await getNavigationButtons(this.$router);
  },

  methods: {
    handleNewSession() {
      this.$router.push(`/demand-letter/new`);
    },

    handleSessionList() {
      this.$router.push('/user-profile?page=1');
    },
  },
});
</script>

<style scoped>
@media (min-width: 300px) {
  .w-menu {
    width: 40% !important;
  }
}

@media (min-width: 650px) {
  .w-menu {
    width: 30% !important;
  }
}

@media (min-width: 1000px) {
  .w-menu {
    width: 20% !important;
  }
}

@media (min-width: 1350px) {
  .w-menu {
    width: 15% !important;
  }
}
</style>
